import React, { useState } from 'react';
import { FaCopy, FaCheck } from 'react-icons/fa';
import './CopyToClipboard.css';

function CopyToClipboard({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <button className={`copy-button ${copied ? 'copied' : ''}`} onClick={handleCopy}>
      {copied ? <FaCheck /> : <FaCopy />}
    </button>
  );
}

export default CopyToClipboard;